import '../../player/00-slideshare_event_manager';
import scribdAuthorize from '../../scribd/scribd_oauth.js';

$(function() {
  'use strict';
  const slideshare_object = window.slideshare_object
  const utils = window.slideshare_object.utils;
  const eventManager = $.slideshareEventManager;

  function logEventToAmplitude(eventName) {
    const slideshow = slideshare_object.slideshow
      const eventOptions = {
        slideshow_id: slideshow.id,
        slideshow_created_at: slideshow.created_at,
        slideshow_category: slideshare_object.gam_cat_name,
        slideshow_language: slideshow.language,
        slideshow_format: slideshow.type,
        source: "slideshow_view",
      }
      amplitude.getInstance().logEvent(eventName, eventOptions);
  }

  /**
   * Scroll to the top of the page unless we're there already.
   * Used by actions that share.
   */
  function scrollWindowToTop() {
    if (window.scrollY) {
      $.scrollTo(0, 500);
    }
  }
  
  /**
   * Trigger the share modal within the player.
   * Setting a dummy GA event prefix (IGNORE_THIS_) because working with the player to
   * move the share modal event is a major PITA. Sorry future self.
   */
  function share() {
    scrollWindowToTop();
    eventManager.trigger('playershare', 'IGNORE_THIS_');
  }
  
  /**
   * Trigger the share modal in the player, triggered after like.
   * Perhaps there's a way to consolidate this with share() but the
   * code is super jank up and I'm running out of time.
   * Sorry future self. I tried.
   */
  function shareAfterLike() {
    scrollWindowToTop();
    if (window.player && window.player.controller) {
      window.player.controller.displayShareScreen({
        gaCategory: 'share_after_like',
        customizations: {
          title: utils.i18n('action-bar.like.why_not_share')
        }
      });
    }
  }
  
  /**
   * Hide the share modal within the player that was triggered on like.
   */
  function hideShareAfterLike() {
    if (window.player && window.player.controller) {
      window.player.controller.hideShareScreen();
    }
  }

  function handleReport (e) {
    if (!utils.isUserAuthenticated()) {
      e.preventDefault();
      e.stopPropagation();
      /**
       * Edge Case Handling: Report is the only action that does not use
       * addAfterLoginEvent, if the user clicks like/follow person, category,
       * comment, clip & click back from Scribd Oauth page, we want to clear
       * the cookie that is set to execute afterLoginEvent
       */
      if (window.cookie('after_login_action') !== null) {
        window.cookie('after_login_action', '', { path: '/', 'max-age': -1 });
      }
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id });
    }
  }

  function updateLikeCount (value) {
    var $counter = $('.j-like-count');
    var count = parseInt($counter.attr('data-favorites-count'), 10) + value;
    $counter.attr('data-favorites-count', count);
    $counter.text(utils.i18n('slideshow.foundation_slideview.likes_count', [{ count: count }]));
  }

  function getPostDataForLike () {
    return {
      slideshow_id: slideshare_object.presentationId,
      user_id: slideshare_object.user.id,
      source: 'slideviewer'
    };
  }

  function saveSlideshowUnlike () {
    $.post(slideshare_object.favorites.delete_url, getPostDataForLike())
      .then(function() {
        $('.j-like-button').removeClass("liked").attr('data-action', 'like').children('i').removeClass('icon-heart-filled').addClass('icon-heart');
        updateLikeCount(-1);
        hideShareAfterLike();
        logEventToAmplitude("slideshow_unliked");
      });
  }

  function saveSlideshowLike () {
    $.post(slideshare_object.favorites.create_url, getPostDataForLike())
      .then(function() {
        $('.j-like-button').addClass("liked").attr('data-action', 'unlike').children('i').removeClass('icon-heart').addClass('icon-heart-filled');
        updateLikeCount(1);
        shareAfterLike();
        logEventToAmplitude("slideshow_liked");
      });
  }

  function handleLike () {
    const dataAction = $('.j-like-button').attr('data-action');

    if (utils.isUserAuthenticated()) {
      if (dataAction === 'like') {
        saveSlideshowLike();
      } else if (dataAction === 'unlike') {
        saveSlideshowUnlike();
      }
    } else {
      var eventConfig = {
        "event": "like",
        "data": { "slideshow_id" : slideshare_object.slideshow.id }
      };
      slideshare_object.addAfterLoginEvent(eventConfig);
      scribdAuthorize({ from_source: window.location.pathname, slideshow_id: slideshare_object.slideshow.id });
    }
  }

  $('.report').on('click', handleReport);
  $('.share').on('click', share);
  $('.j-like-button').on('click', handleLike);
});
